"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon32Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon32Regular = forwardRef_1.forwardRef('ArrowCDownIcon32Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 32 }, props),
        react_1.default.createElement("path", { d: "M27.207 10.793a1 1 0 0 1 0 1.414l-8.379 8.379a4 4 0 0 1-5.656 0l-8.38-8.379a1 1 0 1 1 1.415-1.414l8.379 8.379a2 2 0 0 0 2.828 0l8.379-8.38a1 1 0 0 1 1.414 0Z" })));
});
